exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".stepper {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  margin-top: 20px;\n  margin-left: 20px;\n  color: #31485e; }\n", "", {"version":3,"sources":["/usr/src/app/src/components/Stepper/Stepper.scss"],"names":[],"mappings":"AAAA;EACE,qBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe,EAAE","file":"Stepper.scss","sourcesContent":[".stepper {\n  display: flex;\n  margin-top: 20px;\n  margin-left: 20px;\n  color: #31485e; }\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"sourceMap":true,"minimize":false}!../~/postcss-loader?pack=sass!../~/sass-loader!./components/Stepper/Stepper.scss
// module id = 1279
// module chunks = 0